if (!customElements.get('a-bundle-list')) {
  class ABundleList extends HTMLElement {
    constructor() {
      super();
      this.actionBtn = null;
      this.dialog = null;
      this.closeBtn = null;
      this.slide = null;
      this.slideInlineZIndex = '';
      this.isOpen = false;
      this.onDocClick = this.onDocClick.bind(this);
      this.onMouseEnter = this.onMouseEnter.bind(this);
      this.onMouseLeave = this.onMouseLeave.bind(this);
      this.onHostClick = this.onHostClick.bind(this);
      this.onDialogClick = this.onDialogClick.bind(this);
      this.onCloseBtnClick = this.onCloseBtnClick.bind(this);
    }

    connectedCallback() {
      this.actionBtn = this.querySelector('.a-bundle-list__action-btn');
      this.dialog = this.querySelector('.a-bundle-list__dialog');
      this.closeBtn = this.querySelector('.bundle-list__close');
      this.slide = this.closest('.swiper-slide');
      this.slideInlineZIndex = this.slide ? this.slide.style.zIndex : '';

      if (!this.actionBtn || !this.dialog) return;

      this.addEventListener('click', this.onHostClick);
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.onCloseBtnClick);
      }
      this.dialog.addEventListener('click', this.onDialogClick);
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      document.addEventListener('click', this.onDocClick);
    }

    disconnectedCallback() {
      if (this.actionBtn) {
        this.removeEventListener('click', this.onHostClick);
      }
      if (this.closeBtn) {
        this.closeBtn.removeEventListener('click', this.onCloseBtnClick);
      }
      if (this.dialog) {
        this.dialog.removeEventListener('click', this.onDialogClick);
      }
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      document.removeEventListener('click', this.onDocClick);
    }

    isDesktop() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth > 767;
    }

    onMouseEnter() {
      if (this.isDesktop()) this.openDialog();
    }

    onMouseLeave() {
      if (this.isDesktop()) this.closeDialog();
    }

    onHostClick(event) {
      if (this.isDesktop()) return;
      if (this.dialog && this.dialog.contains(event.target)) return;

      event.preventDefault();
      event.stopPropagation();
      this.toggleDialog();
    }

    onCloseBtnClick() {
      this.closeDialog();
    }

    onDialogClick(event) {
      if (event.target === this.dialog && !this.isDesktop()) {
        this.closeDialog();
        return;
      }
      event.stopPropagation();
    }

    onDocClick(event) {
      if (!this.contains(event.target)) this.closeDialog();
    }

    openDialog() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.updateSlideLayer(true);
      this.dialog.hidden = false;
    }

    closeDialog() {
      if (!this.isOpen) return;
      this.dialog.hidden = true;
      this.updateSlideLayer(false);
      this.isOpen = false;
    }

    toggleDialog() {
      if (!this.isOpen) {
        this.openDialog();
      } else {
        this.closeDialog();
      }
    }

    updateSlideLayer(isActive) {
      if (!this.slide) return;
      if (isActive) {
        this.slide.style.zIndex = '1';
        return;
      }
      this.slide.style.zIndex = this.slideInlineZIndex;
    }
  }

  customElements.define('a-bundle-list', ABundleList);
}